module.exports = __webpack_public_path__ + "img/xig67ak5T.779b9dc3.gif";